import { useState, useEffect } from "react";
import OverviewPage from "./pages/OverviewPage.js";
import DomainsPage from "./pages/DomainsPage.js";
import ClientsPage from "./pages/ClientsPage.js";
import AlertsPage from "./pages/AlertsPage.js";
import SettingsPage from "./pages/SettingsPage.js";

type Page = "overview" | "domains" | "clients" | "alerts" | "settings";

function getPageFromHash(): Page {
  const hash = window.location.hash.replace("#", "");
  if (["overview", "domains", "clients", "alerts", "settings"].includes(hash)) {
    return hash as Page;
  }
  return "overview";
}

export default function App() {
  const [page, setPage] = useState<Page>(getPageFromHash);

  useEffect(() => {
    const handler = () => setPage(getPageFromHash());
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);

  function nav(p: Page) {
    window.location.hash = p;
    setPage(p);
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-800 px-6 py-3 flex items-center gap-6">
        <span className="text-lg font-bold tracking-tight text-white">
          ATLAS
        </span>
        <span className="text-xs text-gray-500">TLS Lifecycle Authority</span>
        <nav className="ml-auto flex gap-4 text-sm">
          {(["overview", "domains", "clients", "alerts", "settings"] as const).map((p) => (
            <button
              key={p}
              onClick={() => nav(p)}
              className={`capitalize px-2 py-1 rounded transition-colors ${
                page === p
                  ? "text-white bg-gray-800"
                  : "text-gray-400 hover:text-white"
              }`}
            >
              {p}
            </button>
          ))}
        </nav>
      </header>

      {/* Page content */}
      <main className="flex-1 px-6 py-6">
        {page === "overview" && <OverviewPage />}
        {page === "domains" && <DomainsPage />}
        {page === "clients" && <ClientsPage />}
        {page === "alerts" && <AlertsPage />}
        {page === "settings" && <SettingsPage />}
      </main>

      <footer className="border-t border-gray-800 px-6 py-2 text-xs text-gray-600">
        ATLAS · Internal MSP Tooling · Part of the Moss Suite
      </footer>
    </div>
  );
}
